module.exports = core_library;